import { ToastProps } from '@ingka/toast';
import { useCallback, useMemo, useState } from 'react';

type ToastMessage = {
    name: string;
    text: string;
    role?: string;
} & Pick<ToastProps, 'actionClick' | 'actionButtonText'>;

const useToast = () => {
    const [toast, setToast] = useState(null as ToastMessage | null);

    const showToast = useCallback(function showToast(options: ToastMessage) {
        setToast(options);
    }, []);

    const removeToast = useCallback(function removeToast() {
        setToast(null);
    }, []);

    const useToast = useMemo(
        () => ({
            showToast,
            removeToast,
            toast,
        }),
        [showToast, removeToast, toast]
    );

    return useToast;
};

export default useToast;
